import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

import { fetchFhirDocuments } from 'store/currentPatient/actions/fhir';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchFhirDocuments.STARTED]: handleActionStart,
  [fetchFhirDocuments.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  [fetchFhirDocuments.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.documents,
  [clearCurrentPatient]: () => initialState,
});
